GoodsWarrantyModalView = require './goods_warranty_modal'
GoodsWarrantyHelpers = require '../../../goods_warranty/common/helpers'

GoodsWarrantyView = Backbone.View.extend
  el: '.goods-warranty'

  events:
    'change .goods-warranty-option': 'updateModelSelectedState'
    'click .more-details': 'showGoodsWarrantyModal'

  initialize: ({goodsWarranty}) ->
    {@dealOptionWarranties, @showMultiOptionBreakout, @showAddToCart} = goodsWarranty
    @listenTo @model, 'change:isSelected', @updateWarrantyCheckboxState
    @initializeWarrantyOption()
    @initializeWarrantyModal()
    @initializeMultiOptionBreakoutPane() if @showMultiOptionBreakout

    window.DealEventPipe.on 'goodsOptionUpdate', (data = {}) =>
      @optionInfo = data
      @model.set
        buyUrl: data.buyUrl
        bundleCheckoutUrl: @getBundleCheckoutUrl()
      @updateWarrantyOption()
      @updateWarrantyModal()
      @updateBuyButtonUrl()
      @updateBuyButtonText()

  initializeMultiOptionBreakoutPane: ->
    $multiBreakoutOptions = $('#options-pane .option a')
    return unless $multiBreakoutOptions?.length

    $multiBreakoutOptions.click (e) =>
      return unless @model.get('isSelected')
      $option = $(e.currentTarget)
      {deal, uuid} = $option.data()
      @optionInfo = {dealUuid: deal, uuid}

      bundleCheckoutUrl = @getBundleCheckoutUrl()
      $option.attr 'href', bundleCheckoutUrl if bundleCheckoutUrl?.length

  initializeWarrantyOption: ->
    @$buyButton = $('#buy, a.buy-button')
    @$goodsWarrantyOption = $('.goods-warranty-option')
    @$warrantyMessage = @$el.find '.warranty-option-message .warranty-message-content'
    @$warrantyMessage = @$el.find '.warranty-option-message' unless @$warrantyMessage.length > 0

    @model.set 'isSelected', false

  initializeWarrantyModal: ->
    @$warrantyModal = $('#goods-warranty-modal')
    @$warrantyModalTitle = @$warrantyModal.find '.warranty-option-message'
    @$warrantyModalServiceMessage = @$warrantyModal.find '.bundle-service-messages'
    @modalView = new GoodsWarrantyModalView {@model}

  getBundleCheckoutUrl: ->
    {dealUuid, uuid} = @optionInfo
    return unless warrantyOption = GoodsWarrantyHelpers.getFirstWarrantyOption uuid, @dealOptionWarranties
    $multiBreakoutOptions = $('#options-pane .option a')
    GoodsWarrantyHelpers.generateBundleCheckoutUrl dealUuid, uuid, warrantyOption

  showGoodsWarrantyModal: ->
    @$body ?= $('body')
    @$htmlbody ?= $("html, body")
    @$mainTouchPane ?= $('#global-container')

    @modalView.scrollOffset = @$body.scrollTop()
    @$mainTouchPane.hide()
    @$warrantyModal.show()
    @$htmlbody.animate scrollTop: 0, 'slow'
    @$body.animate scrollTop: 0, 'slow'

  updateModelSelectedState: (e) ->
    @model.set 'isSelected', $(e.currentTarget).prop 'checked'

  updateBuyButtonUrl: ->
    buyButtonUrl = if @model.get('isSelected') then @model.get('bundleCheckoutUrl') else @model.get('buyUrl')
    @$buyButton.attr 'href', buyButtonUrl if buyButtonUrl?.length

  updateBuyButtonText: ->
    return unless @showAddToCart
    @$body ?= $('body')
    if @model.get('isSelected')
      buyText = I18n.t 'js.modules.buy_button.buy'
      buyText = buyText.replace('!','') if @$body.hasClass('is-web')
    else
      buyText = I18n.t 'js.modules.buy_button.add_to_cart'

    @$buyButton.text buyText

  updateWarrantyCheckboxState: ->
    if @$goodsWarrantyOption.prop('checked') != @model.get('isSelected')
      @$goodsWarrantyOption.prop('checked', @model.get('isSelected')).change()
    @updateBuyButtonUrl() if @showMultiOptionBreakout or @optionInfo?.variationsSelected
    @updateBuyButtonText()

  updateWarrantyModal: ->
    @$warrantyModal
      .removeClass 'replacement-plan-selected repair-plan-selected'
      .addClass @warrantyOption?.selectedCssClass
    @serviceMessages = @warrantyOption?.warrantyPitchHtml
    @$warrantyModalTitle.html @warrantyMessage
    @$warrantyModalServiceMessage.html @serviceMessages

  updateWarrantyOption: ->
    @warrantyOption = GoodsWarrantyHelpers.getFirstWarrantyOption @optionInfo?.uuid, @dealOptionWarranties
    @warrantyMessage = @warrantyOption?.warrantyMessage
    @$warrantyMessage.html @warrantyMessage
    @$el.toggleClass 'close', not @warrantyMessage?

module.exports = GoodsWarrantyView
